import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import {amber, green} from '@mui/material/colors/index';
import IconButton from '@mui/material/IconButton/index';
import SnackbarContent from '@mui/material/SnackbarContent/index';
import WarningIcon from '@mui/icons-material/Warning';
import {makeStyles} from '@mui/styles';
import Snackbar from "@mui/material/Snackbar";
import clsx from "clsx";

const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
};

const useStyles1 = makeStyles(theme => ({
    success: {
        backgroundColor: green[600],
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
    info: {
        backgroundColor: theme.palette.primary.main,
    },
    warning: {
        backgroundColor: amber[700],
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
}));
export default function SnackbarMessage({
                                            message, onClose, type, anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'left',
    }, autoHideDuration = 6000, action = undefined, ...props
                                        }) {
    const classes = useStyles1();
    const Icon = variantIcon[type];
    let act;
    if (onClose !== undefined) {
        act = [
            action,
            <IconButton key="close" color="inherit" onClick={onClose} size="large">
                <CloseIcon/>
            </IconButton>,
        ];
    }
    const content = (
        <SnackbarContent
            className={classes[type]}
            message={
                <span className={classes.message}>
                        <Icon className={clsx(classes.icon, classes.iconVariant)}/>
                    {message}
                </span>
            }
            action={act}
            {...props}
        />
    );
    if (anchorOrigin === false) {
        return content;
    } else {
        return (
            <Snackbar
                className={classes.margin}
                anchorOrigin={anchorOrigin}
                open={true}
                autoHideDuration={autoHideDuration}
                onClose={onClose}
            >
                {content}
            </Snackbar>
        );
    }
}
